import { useState, useEffect } from "react";
import { Alert } from "shards-react";

/**
 * Export a component that contain default error message.
 */

const AlertMessage = ({
  alertMessage,
  background = "danger",
  classes = "",
  autoDismiss,
  manualDismiss,
  setMessage = () => null,
  setErrMsg,
  alertDuration = 5000,
}) => {
  const [showMsg, setShowMsg] = useState(true);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (autoDismiss) {
        setMessage(false);
        if (setErrMsg) setErrMsg("");
        return setShowMsg(false);
      } else {
        return null;
      }
    }, alertDuration);

    return () => {
      clearTimeout(timer);
    };
  }, [autoDismiss, setMessage, setErrMsg]);

  return (
    <Alert
      open={showMsg}
      {...manualDismiss}
      className={`text-center bg-${background} ${classes}`.trim()}
    >
      <span>
        <i className="fa fa-info mx-2" />
        {alertMessage}
      </span>
    </Alert>
  );
};

export default AlertMessage;
